// extracted by mini-css-extract-plugin
export default {"editArticleContainer":"ArticleSuggestion_editArticleContainer__RKmhg"};